module.exports = __webpack_public_path__ + "static/media/AUT.43b76c43.jpg";